import React, { useState, useEffect } from 'react'
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from './contexts/ThemeContext'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import PeopleList from './pages/PeopleList'
import AtendimentosList from './pages/AtendimentosList'
import FuncionariosList from './pages/FuncionariosList'
import Login from './pages/Login'
import RecuperarSenha from './pages/RecuperarSenha'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import './App.css'

function AppRoutes() {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/recuperar-senha" element={<RecuperarSenha />} />
        <Route path="*" element={<Login />} />
      </Routes>
    )
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/pessoas" element={<ProtectedRoute requiredViewPermission="ver_pessoa"><PeopleList /></ProtectedRoute>} />
        <Route path="/funcionarios" element={<ProtectedRoute requiredViewPermission="ver_funcionario"><FuncionariosList /></ProtectedRoute>} />
        <Route path="/atendimentos" element={<ProtectedRoute requiredViewPermission="ver_atendimento"><AtendimentosList /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  )
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
